export default function getCategoryHeaderData(props) {
  const {
    categoryHeader: {
      fields: { title, highlightedText, text, buttonLabel, buttonAction },
    },
  } = props;

  const data = {};
  data.title = title;
  data.highlight = highlightedText;
  data.bodyText = text;
  data.buttonLabel = buttonLabel || 'Get their secrets';
  data.buttonAction = buttonAction === 'Subscribe to newsletter' ? 'subscribe' : 'requestInvite';

  return Object.keys(data).length ? data : false;
}
